<template>
  <div class="c-notification-list">
    <notification-item
      v-for="notification in notifications"
      :notification="notification"
      :type="notification.type"
      :key="notification.timestamp"
    ></notification-item>
  </div>
</template>

<script>
import NotificationItem from '@/components/NotificationItem';

export default {
  name: 'notification-list',

  components: {
    NotificationItem,
  },

  computed: {
    notifications() {
      return this.$store.state.notifications.collection;
    },
  },
};
</script>

<style lang="scss">
.c-notification-list {
  position: fixed;
  bottom: 4em;
  left: 1em;
  right: 1em;
  z-index: 100;
  pointer-events: none;

  @media screen and (min-width: 1024px) {
    bottom: 2em;
    left: 6em;
    right: 6em;
  }
}
</style>

